import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory, useParams} from "react-router-dom";
import LoadingSpinner from "../../../components/loading-spinner";
import Modal from "../../../components/modal";
import {
    clear_maintenance_survey,
    getAllMaintenanceSurvey,
    getItemMaintenanceSurvey,
    UPDATE_MAINTENANCE_SURVEY,
    updateMaintenanceSurvey
} from "../../../redux/maintenance_survey";
import TextArea from "../../../components/text-area";
import CheckBox from "../../../components/check-box";
import {
    clear_maintenance_survey_option,
    CREATE_MAINTENANCE_SURVEY_OPTION, createMaintenanceSurveyOption,
    UPDATE_MAINTENANCE_SURVEY_OPTION, updateMaintenanceSurveyOption
} from "../../../redux/maintenance_survey_option";

const UpdateMaintenanceSurvey = () => {
    let history = useHistory();
    const {id} = useParams();

    const dispatch = useDispatch();
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const _update_maintenance_survey = useSelector((state) => state.maintenance_survey_module._update_maintenance_survey);
    const _create_maintenance_survey_option = useSelector((state) => state.maintenance_survey_option_module._create_maintenance_survey_option);
    const _update_maintenance_survey_option = useSelector((state) => state.maintenance_survey_option_module._update_maintenance_survey_option);

    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState(false);

    const [form, setForm] = useState({
        descripcion: "",
        activo: true,
        opciones: [],
    });

    const [data, setData] = useState({
        encuesta_id: parseInt(id),
        opcion_id: 0,
        descripcion: '',
        activo: true,
    });

    useEffect(() => {
        // eslint-disable-next-line
        searchItemMaintenanceSurvey();
        // eslint-disable-next-line
    }, [token, id]);


    async function searchItemMaintenanceSurvey() {
        setIsLoading(true);
        try {
            const response = await getItemMaintenanceSurvey(token, id);
            if (response && response.data && response.data.datos) {
                let v = response.data.datos[0];
                setForm({
                    descripcion: v.descripcion,
                    activo: v.activo,
                    opciones: v.opciones,
                })
            }
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
        }
    }

    const handleChange = (e) => {
        if (e.target.name === 'activo') {
            setForm({
                ...form,
                [e.target.name]: e.target.checked,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    useEffect(() => {
        if (_update_maintenance_survey.status === 200) {
            dispatch(clear_maintenance_survey(UPDATE_MAINTENANCE_SURVEY));
            dispatch(getAllMaintenanceSurvey(token));
            setIsLoading(false);
            history.push("/encuestas-mantenimientos");
        } else {
            if (_update_maintenance_survey.status !== 0) {
                toast.error(_update_maintenance_survey.message);
                setIsLoading(false);
            }
        }
    }, [_update_maintenance_survey, dispatch, history, token]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        if (form.descripcion === "") {
            toast.error("Debe ingresar la descripción", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(updateMaintenanceSurvey(token, id, form));
    };

    const handleChangeData = (e) => {
        if (e.target.name === 'activo') {
            setData({
                ...data,
                [e.target.name]: e.target.checked,
            });
        } else {
            setData({
                ...data,
                [e.target.name]: e.target.value,
            });
        }
    };

    useEffect(() => {
        if (_create_maintenance_survey_option.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_maintenance_survey_option(CREATE_MAINTENANCE_SURVEY_OPTION));
            searchItemMaintenanceSurvey();
            setIsLoading(false);
            setModal(false);
        } else if (_create_maintenance_survey_option.status !== 0) {
            dispatch(clear_maintenance_survey_option(CREATE_MAINTENANCE_SURVEY_OPTION));
            toast.error(_create_maintenance_survey_option.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_maintenance_survey_option, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_maintenance_survey_option.status === 200) {
            dispatch(clear_maintenance_survey_option(UPDATE_MAINTENANCE_SURVEY_OPTION));
            searchItemMaintenanceSurvey();
            setIsLoading(false);
            setModal(false);
        } else {
            if (_update_maintenance_survey_option.status !== 0) {
                dispatch(clear_maintenance_survey_option(UPDATE_MAINTENANCE_SURVEY_OPTION));
                toast.error(_update_maintenance_survey_option.message);
                setIsLoading(false);
            }
        }
        // eslint-disable-next-line
    }, [_update_maintenance_survey_option, dispatch]);

    const handleSubmitOption = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (data.descripcion === 0) {
            toast.error("Debe ingresar la opción", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (data.opcion_id === 0) {
            dispatch(createMaintenanceSurveyOption(token, data));
        } else {
            dispatch(updateMaintenanceSurveyOption(token, parseInt(data.opcion_id), data));
        }
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <div><ToastContainer/></div>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Encuesta de mantenimiento"
                            items={[{label: "Encuestas de mantenimientos", link: "/encuestas-mantenimientos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar Encuesta</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <TextArea
                                                name="descripcion"
                                                label="Descripción"
                                                placeholder=""
                                                value={form.descripcion}
                                                onChange={handleChange}
                                                rows={3}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <CheckBox label="Activo" name="activo" id="activo" onChange={handleChange}
                                                      state={form.activo}/>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-6 col-12">
                                            <h5>Opciones</h5>
                                        </div>
                                        <div className="col-md-6 col-12 text-right">
                                            <Button type="button" text="Agregar opción" theme="secondary" classes="mb-1"
                                                    onChange={() => {
                                                        setData({
                                                            encuesta_id: id,
                                                            opcion_id: 0,
                                                            descripcion: '',
                                                            activo: true,
                                                        });
                                                        setModal(true);
                                                    }}/>
                                        </div>
                                        {(form.opciones && form.opciones.length > 0) &&
                                            form.opciones.map((g) =>
                                                <div className="col-12" style={{padding: "0 2em"}}>
                                                    <div className="row border_card">
                                                        <div className="col-md-3">
                                                            <span>Opción</span>
                                                            <p className="border_card">{g.descripcion}</p>
                                                        </div>
                                                        <div className="col-md-3 mt-2">
                                                            <div className="d-flex">
                                                                <p style={{marginTop: 5}}>Activo: </p>
                                                                {g.activo ?
                                                                    <div><i className="bx bx-check-square" style={{fontSize: '2em'}}/></div>
                                                                    :
                                                                    <div><i className="bx bx-checkbox" style={{fontSize: '2em'}}/></div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="col-6 text-right mt-1">
                                                <Button type="button" text="Editar" theme="warning"
                                                            classes="mb-1"
                                                            onChange={() => {
                                                                setData({
                                                                    encuesta_id: id,
                                                                    opcion_id: parseInt(g.id),
                                                                    descripcion: g.descripcion,
                                                                    activo: g.activo,
                                                                });
                                                                setModal(true);
                                                            }}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="card-footer d-flex justify-content-end">
                                        <Link to="/encuestas-mantenimientos" className="btn btn-danger m-1">
                                            Cancelar
                                        </Link>
                                        <Button
                                            type="submit"
                                            text={<><i className="bx bx-save"/> Guardar</>}
                                            theme="success"
                                            disabled={isLoading}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmitOption}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">{data.opcion_id === 0 ? 'Crear' : 'Editar'} opción</h5>
                        <div className="form-group">
                            <Input
                                label="Descripción"
                                name="descripcion"
                                value={data.descripcion}
                                onChange={handleChangeData}
                            />
                        </div>
                        {parseInt(data.opcion_id) !== 0 &&
                            <div className="form-group">
                                <CheckBox label="Activo" name="activo" id="activo_opcion" onChange={handleChangeData} state={data.activo}/>
                            </div>
                        }
                    </div>
                    <div className="text-center">
                        <button type="button" className="btn btn-outline-dark" onClick={() => {
                            setModal(false);
                        }}> Cancelar
                        </button>
                        <Button type="submit" text="Guardar" theme="success" classes="m-1"/>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default UpdateMaintenanceSurvey;
